export default __webpack_public_path__ + "static/media/ps.190a5900.svg";